import { useFlags } from '@chargeafter/feature-flag';
import { useGetInteractionOptions } from '../../../services/configManager';
import { useGetValidAccounts } from '../../../services/customersTabManager';
import {
  useGetApprovingLender,
  useGetConsumer,
} from '../../../services/flowManager';
import {
  useGetCheckoutConfiguration,
  useGetLenderSettings,
} from '../../../services/lendersConfigurationManager';

export const useCheckoutConfig = () => {
  // this gets options from the peers endpoint from operate
  const {
    checkout,
    expressCheckout,
    checkoutLink,
    checkoutQrCode,
    checkoutSms,
    expressCheckoutLink,
    expressCheckoutQrCode,
    expressCheckoutSms,
  } = useGetInteractionOptions();

  // consumer details from selected consumer
  const consumer = useGetConsumer();

  // this is the lender selected from the consumer approval in the consumer tab list
  const currentLenderId = useGetApprovingLender();

  // this is the v3/configurations endpoint
  const checkoutConfigurations = useGetCheckoutConfiguration();

  // this is the selected lender specific settings from the operate/.../integration/lender/${lenderId} endpoint
  const currentLenderSettings = useGetLenderSettings(currentLenderId);

  // this is the list of valid accounts for the consumer endpoint
  const consumersValidAccounts = useGetValidAccounts();

  const consumerAccountsFirstLenderId =
    consumersValidAccounts?.[0]?.lenderId ?? '';

  // this is the prime lender specific settings from the operate/.../integration/lender/${lenderId} endpoint
  const firstValidAccountLenderSettings = useGetLenderSettings(
    consumerAccountsFirstLenderId,
  );

  const { ffShouldShowCheckoutButtonAlways } = useFlags();

  const primeLenderSettings =
    checkoutConfigurations?.lendersConfigurations[0].configuration;

  const lenderSettings =
    (!consumer && primeLenderSettings) ||
    (!!currentLenderId && currentLenderSettings?.options) ||
    firstValidAccountLenderSettings?.options;

  const isSelectedLenderAllowCheckout =
    checkout && lenderSettings?.allowCheckout;

  const isSelectedLenderAllowExpressCheckout =
    !consumer && expressCheckout && lenderSettings?.allowExpressCheckout;

  const isExpressSendLinkAllowed =
    !consumer &&
    (expressCheckoutLink || expressCheckoutQrCode || expressCheckoutSms);

  const shouldShowCheckoutSendLink =
    checkoutLink || checkoutQrCode || checkoutSms || isExpressSendLinkAllowed;

  const isExpressCheckoutAllowed =
    !consumer &&
    (expressCheckoutLink ||
      expressCheckoutQrCode ||
      expressCheckoutSms ||
      isSelectedLenderAllowExpressCheckout);

  const isCheckoutAllowed =
    isSelectedLenderAllowCheckout ||
    checkoutLink ||
    checkoutQrCode ||
    checkoutSms;

  return {
    isCheckoutAllowed,
    isExpressCheckoutAllowed,
    shouldShowCheckoutSendLink,
    shouldShowCheckoutButton:
      isSelectedLenderAllowCheckout ||
      isSelectedLenderAllowExpressCheckout ||
      ffShouldShowCheckoutButtonAlways,
  };
};
